"use client"

import { useState, useEffect, useCallback } from "react"
import { useLocation } from "react-router-dom"
import { ThemeProvider } from "@mui/material/styles"
import theme from "../../muiThemes/Themes.js"
import { subscribePdfPreview } from "../../context/pdf_esqueletos/helpers/pdfPreviewBus.js"
import PdfPreviewModal from "./PdfPreviewModal.js"

/**
 * Proveedor global del visor de PDFs. Montar una sola vez en la raíz de la app.
 * Se suscribe al pdfPreviewBus y abre PdfPreviewModal cuando llega un PDF.
 */
export default function PdfPreviewProvider({ children }) {
  const [previewState, setPreviewState] = useState({
    open: false,
    blob: null,
    fileName: null,
    title: null,
    compartir: null,
  })

  const location = useLocation()

  const openPreview = useCallback((payload) => {
    setPreviewState({
      open: true,
      blob: payload.blob,
      fileName: payload.fileName ?? "documento.pdf",
      title: payload.title ?? payload.fileName ?? "Vista previa",
      compartir: payload.compartir ?? null,
    })
  }, [])

  const closePreview = useCallback(() => {
    setPreviewState((prev) => ({ ...prev, open: false, blob: null, compartir: null }))
  }, [])

  // Suscribirse al bus al montar
  useEffect(() => {
    const unsubscribe = subscribePdfPreview(openPreview)
    return unsubscribe
  }, [openPreview])

  // Cerrar al cambiar de ruta (evita que el PDF de una pantalla quede abierto en otra)
  useEffect(() => {
    closePreview()
  }, [location.pathname, closePreview])

  return (
    <ThemeProvider theme={theme}>
      {children}
      <PdfPreviewModal
        open={previewState.open}
        blob={previewState.blob}
        fileName={previewState.fileName}
        title={previewState.title}
        compartir={previewState.compartir}
        onClose={closePreview}
      />
    </ThemeProvider>
  )
}
